import throttle from 'lodash/throttle';

const setCssProperties = () => {
	// First we get the viewport height and we multiple it by 1% to get a value for a vh unit
	let vh = Math.min(window.innerHeight, window.outerHeight) * 0.01;
	// Then we set the value in the --vh custom property to the root of the document
	document.documentElement.style.setProperty('--vh', `${vh}px`);
};
setCssProperties();
window.addEventListener(
	'resize',
	throttle(() => {
		setCssProperties();
	}, 100)
);
